import { Col, Row } from "antd";
import ContentLoader from "react-content-loader";

const AccessCodesLoader = (props) => {
  return (
    <Row>
      <Col span={8}>
        <ContentLoader viewBox="0 0 100% 50" height={"50"} width={"100%"} {...props}>
          <rect x="0" y="0" rx="0" ry="0" width="150" height="20" />
        </ContentLoader>
      </Col>
      <Col span={8}>
        <ContentLoader viewBox="0 0 100% 50" height={"50"} width={"100%"} {...props}>
          <rect x="0" y="0" rx="0" ry="0" width="150" height="20" />
        </ContentLoader>
      </Col>
      <Col span={8}>
        <ContentLoader viewBox="0 0 100% 50" height={"50"} width={"100%"} {...props}>
          <rect x="0" y="0" rx="0" ry="0" width="150" height="20" />
        </ContentLoader>
      </Col>
    </Row>
  );
};

export default AccessCodesLoader;
